import React from 'react'
import { documentStateLabel } from '../../utils/display_names'
import { Button } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'

const IdDocumentTrPdf = (props) => {
  return (
    <tr key={props.entry.id}>
      <td>{props.entry.id}</td>
      <td>
        <Button href={props.entry.document} target='_blank' rel='noopener noreferrer'>
          <i className='fa fa-file-pdf-o' /> Open
        </Button>
      </td>
      <td>{props.entry.document_type && props.entry.document_type.toUpperCase()}</td>
      <td>{props.entry.is_active ? 'Yes' : 'No'}</td>
      <td>{documentStateLabel(props.entry.state).toUpperCase()}</td>
      <td>{formatTimeString(props.entry.created)}</td>
      <td>{formatTimeString(props.entry.updated)}</td>
    </tr>
  )
}

export default IdDocumentTrPdf
